(function () {
  function init() {
    var cta = document.getElementById('ThyredStickyCta');
    if (!cta) return;
    var hero = document.querySelector('[data-thyred-hero]') || document.querySelector('.hero');
    var trigger = function () {
      var sc = window.scrollY;
      var heroBottom = hero ? hero.getBoundingClientRect().bottom + sc : window.innerHeight;
      var order = document.getElementById('order');
      var orderTop = order ? order.getBoundingClientRect().top + sc : Infinity;
      var past = sc > heroBottom - 120;
      var beforeOrder = sc + window.innerHeight < orderTop + 120;
      if (past && beforeOrder) cta.classList.add('show');
      else cta.classList.remove('show');
    };
    trigger();
    window.addEventListener('scroll', trigger, { passive: true });
    window.addEventListener('resize', trigger);
  }
  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
